import { render } from "./UserProfileProjectsSection.vue?vue&type=template&id=112ef6e0"
import script from "./UserProfileProjectsSection.vue?vue&type=script&lang=js"
export * from "./UserProfileProjectsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__